import React, { useState, useEffect } from 'react';
import { CModal, CModalBody, CModalFooter, CButton } from '@coreui/react';
import { IoWarning } from 'react-icons/io5';

const ReusableDialog = ({ show: externalShow, onClose, title, message, onPrimaryAction, primaryActionText, primaryActionColor = 'dark', onSecondaryAction, secondaryActionText, iconDisplay: IconComponent = IoWarning, iconColor }) => {
  const [internalShow, setInternalShow] = useState(externalShow);
  const handleClose = () => {
    setInternalShow(false);
    if (onClose) onClose();
  };
  useEffect(() => {
    setInternalShow(externalShow);
  }, [externalShow]);
  return (
    <CModal show={internalShow} onClose={handleClose} centered className="p-3" closeOnBackdrop={false}>
      <CModalBody className="py-4 px-4 d-flex flex-column align-items-start">
        <div className="d-flex align-items-center mb-3 w-100">
          <IconComponent size={36} className="me-2 mr-2" style={{ color: iconColor }} />
          <h3 className="fw-bold mb-0" style={{ lineHeight: '36px' }}>
            {title || 'Dialog Title'}
          </h3>
        </div>
        <div className="text-muted mb-0 w-100">{message || 'Dialog message goes here.'}</div>
      </CModalBody>
      <CModalFooter className="justify-content-end w-100">
        <CButton color="dark" variant="ghost" onClick={handleClose} className="px-4">
          Cancel
        </CButton>
        <CButton color={primaryActionColor} variant={onSecondaryAction ? "outline" : undefined} onClick={onPrimaryAction} className="px-4 ms-2">
          {primaryActionText || 'Request Approval'}
        </CButton>
        {onSecondaryAction && (
          <CButton color="dark" onClick={onSecondaryAction} className="px-4 ms-2">
            {secondaryActionText || 'Subscribe'}
          </CButton>
        )}
      </CModalFooter>
    </CModal>
  );
};

export default ReusableDialog;
